module.exports = __webpack_public_path__ + "static/POLITICA_PRIVACIDADE_-_VALE_-_Encontro_de_Especialistas-8f6f1e574f017ad49fd0498cf9376ee3.pdf";